import { useCallback, useEffect, useState } from 'react';
import { createHookContext } from '@clover-util/react-context';
import { useWindowSize } from 'hooks/breakpoints';
import { KEY } from 'util/Input';

export const { useCartPreview, CartPreviewProvider } = createHookContext('CartPreview', () => {
  const [cartPreviewVisible, setCartPreviewVisible] = useState(false);
  const openCartPreview = useCallback(() => {
    if (!cartPreviewVisible) setCartPreviewVisible(true);
  }, [cartPreviewVisible]);
  const closeCartPreview = useCallback(() => setCartPreviewVisible(false), []);

  const { isDesktop } = useWindowSize();

  // For under Tablet size, make sure side panel is closed
  useEffect(() => {
    if (!isDesktop) closeCartPreview();
  }, [closeCartPreview, isDesktop]);

  // Listen for esc
  useEffect(() => {
    if (cartPreviewVisible){
      const handleKeyDownEsc = (e: KeyboardEvent) => {
        if (e.key === KEY.ESC) {
          e.stopPropagation();
          closeCartPreview();
        }
      };
      window.addEventListener('keydown', handleKeyDownEsc);

      return () => window.removeEventListener('keydown', handleKeyDownEsc);
    }
  }, [cartPreviewVisible, closeCartPreview]);

  return {
    cartPreviewVisible,
    openCartPreview,
    closeCartPreview,
  };
});
